
import React from "react";
import { BsPencil } from "react-icons/bs";

const TaskInfoSection = ({
  tranId,
  techName,
  serialNumber,
  versionAssigned,
  onSerialNumberChange,
  onVersionChange,
  canEdit = false,
}) => {
  return (
    <>
      <div className="row mt-3">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Order ID</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            className="form-control"
            name="tranId"
            type="text"
            value={tranId}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">TECH</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            className="form-control"
            name="techName"
            type="text"
            value={techName}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Serial Number</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            className="form-control"
            name="serialNumber"
            type="text"
            value={serialNumber}
            onChange={canEdit ? onSerialNumberChange : undefined}
            disabled={!canEdit}
          />
          {canEdit && <BsPencil className="icon_dis" />}
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Version Assigned</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            className="form-control"
            name="versionAssigned"
            type="text"
            value={versionAssigned}
            onChange={canEdit ? onVersionChange : undefined}
            disabled={!canEdit}
          />
          {canEdit && <BsPencil className="icon_dis" />}
        </div>
      </div>
    </>
  );
};

export default TaskInfoSection;

